import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Ramp } from 'src/app/admin/models/ramp.model';
import { RampService } from 'src/app/admin/services/ramp.service';

@Component({
  selector: 'app-delete-ramp-modal',
  templateUrl: './delete-ramp-modal.component.html',
  styleUrls: ['./delete-ramp-modal.component.scss'],
})
export class DeleteRampModalComponent implements OnInit {
ramp:Ramp;

  constructor(private modalController: ModalController, private rampService: RampService) { }

  ngOnInit() {}


  removeRamp() {
    this.rampService.deleteRamp(this.ramp.id).subscribe(res => {
      this.rampService.getAllRamp({currentPage: 1, itemsPerPage: 100,
        ulaznaQuery: '', izlaznaQuery: '', brojRampeQuery: '',roomNameQuery:'',StatusQuery:''});
      this.dismissModal();
    },(err) => {
      console.error(err);
    })
  }

  dismissModal() {
    this.modalController.dismiss();
  }

}
